module.exports = __webpack_public_path__ + "img/fail.1d25e453.png";